module.exports = __webpack_public_path__ + "img/special1.c285d8db.png";